export type ListSearch = { q?: string; sort?: "name" | "createdAt" | "updatedAt"; direction?: "asc" | "desc" }

export function validateListSearch(search: Record<string, unknown>): ListSearch {
    const q = typeof search.q === "string" && search.q.trim() ? search.q.trim() : undefined
    const sort = ["name", "createdAt", "updatedAt"].includes(String(search.sort))
        ? (search.sort as ListSearch["sort"])
        : undefined
    const direction = search.direction === "asc" || search.direction === "desc" ? search.direction : undefined
    return { ...(q ? { q } : {}), ...(sort ? { sort } : {}), ...(direction ? { direction } : {}) }
}
